import { render, staticRenderFns } from "./advChannelSummary.vue?vue&type=template&id=5559b546&scoped=true"
import script from "./advChannelSummary.vue?vue&type=script&lang=js"
export * from "./advChannelSummary.vue?vue&type=script&lang=js"
import style0 from "./advChannelSummary.vue?vue&type=style&index=0&id=5559b546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5559b546",
  null
  
)

export default component.exports